import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import CustomSnackbar from "../components/CustomSnackbar";
import KeywordBox from "../components/KeywordBox";
import CrmTabs from "../crm/CrmTabs";
import { adminCrmReferralEventPath, adminCrmReferralInvitersPath } from "../crm/crmRoutes";
import CreateReferralEventDialog from "./CreateReferralEventDialog";
import ReferralService from "./ReferralService";
import { getColumns } from "./getColumns";

export default function ReferralMain() {
    const navigate = useNavigate();
    const [pageModel, setPageModel] = useState({ page: 0, pageSize: 25 });
    const [sort, setSort] = useState([{ field: "createdAt", sort: "desc" }]);
    const [rowCount, setRowCount] = useState(0);
    const [rows, setRows] = useState([]);
    const [keyword, setKeyword] = useState();
    const [reload, setReload] = useState();

    const [openCreateDialog, setOpenCreateDialog] = useState(false);

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severity, setSeverity] = useState("success");
    const [message, setMessage] = useState("");

    useEffect(() => {
        ReferralService.requestList(pageModel, sort, setRows, setRowCount, keyword);
    }, [pageModel, sort, keyword, reload]);

    const handleSort = (model) => {
        setSort(model);
    };

    const handleKeyword = (k) => {
        setKeyword(k);
    };

    const handleSnackBar = (severity, message) => {
        setOpenSnackbar(true);
        setSeverity(severity);
        setMessage(message);
    };

    const handleCreateSuccess = () => {
        handleSnackBar("success", "Referral event created successfully");
        setReload(moment());
    };

    const handleRowClick = (params) => {
        navigate(adminCrmReferralEventPath(params.id));
    };

    const handleDetailClick = (eventId) => {
        navigate(adminCrmReferralInvitersPath(eventId));
    };

    return (
        <Box sx={{ flexGrow: 1, gap: 2, display: "flex", flexDirection: "column" }}>
            <CrmTabs />
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 8 }}>
                    <KeywordBox callback={handleKeyword} />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<AddIcon />}
                        onClick={() => setOpenCreateDialog(true)}
                    >
                        Create Event
                    </Button>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <DataGrid
                        rows={rows}
                        columns={getColumns(handleDetailClick)}
                        rowCount={rowCount}
                        pageSizeOptions={[25, 50, 100]}
                        paginationModel={pageModel}
                        onPaginationModelChange={(m) => setPageModel(m)}
                        disableSelectionOnClick
                        experimentalFeatures={{ newEditingApi: true }}
                        paginationMode={"server"}
                        onRowClick={handleRowClick}
                        onSortModelChange={handleSort}
                        columnVisibilityModel={{ id: false }}
                        autoHeight={true}
                        hideFooterSelectedRowCount
                        initialState={{
                            columns: {
                                columnVisibilityModel: {
                                    id: false,
                                },
                            },
                        }}
                    />
                </Grid>
            </Grid>

            <CustomSnackbar open={openSnackbar} setOpen={setOpenSnackbar} severity={severity} message={message} />

            <CreateReferralEventDialog
                open={openCreateDialog}
                setOpen={setOpenCreateDialog}
                callback={handleCreateSuccess}
            />
        </Box>
    );
}

